import { render, staticRenderFns } from "./IconMessage.vue?vue&type=template&id=a1a71536&"
import script from "./IconMessage.vue?vue&type=script&lang=js&"
export * from "./IconMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports